export const STOREPAGE = () => `/store`;

/**
 * Ficha da loja (plan-notificacoes-whatsapp, 22/10/2026): um lugar só para os
 * dados, o horário, a posição, a equipe e o quiosque. Fica fora de `/store` e
 * de `/dp` de propósito: abre para o ADMIN e para o DP, e cada aba segue o papel.
 */
export const STORE_DETAIL_PAGE = (id = ":storeId") => `/lojas/${id}`;
